import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Box.css'

@observer
export default class Box extends Component<
  {css?: any; children: React.ReactNode; onDarkBackground?: boolean},
  {}
> {
  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container', props.onDarkBackground === true && 'onDarkBackground')}>
        <div {...classes('thingy')} />
        {props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/Box.tsx